export default "__VITE_ASSET__C7oR46F1__"